import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { SelectableItems } from 'ps-shared-ui/v3/SelectableItems';
import classnames from 'classnames';
import './SkillsOrCerts.scss';
import { debounce } from 'ps-shared-ui/v3/debounce';

export default class SkillsOrCerts extends Component {
  static propTypes = {
    selectedItemsNameList: PropTypes.arrayOf(PropTypes.string),
    selectedItemsList: PropTypes.arrayOf(PropTypes.object),
    orgJobTitle: PropTypes.string,
    jobCode: PropTypes.string,
    workLocationExact: PropTypes.string,
    orgJobId: PropTypes.number,
    allAvailableItemsListByJob: PropTypes.arrayOf(PropTypes.object),
    itemsSearch: PropTypes.func,
    saveJob: PropTypes.func,
    saveJobAndUpdatePay: PropTypes.func,
    returnSkillCertItems: PropTypes.func,
    jobEditSection: PropTypes.string,
    possibleItems: PropTypes.arrayOf(PropTypes.string),
    headerText: PropTypes.string,
    title: PropTypes.string,
    searchPlaceholderText: PropTypes.string,
    searchItems: PropTypes.arrayOf(PropTypes.object),
    className: PropTypes.string,
    disabled: PropTypes.bool,
    quickUpdateJobDetailsAndPay: PropTypes.func,
    isMP: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.itemSelectFunc = this.itemSelect.bind(this);
    this.throttleItemSelect = debounce(this.itemSelectFunc, 250);
    this.state = {
      value: this.props.selectedItemsNameList,
      saveItemList: []
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (!props.isMP) {
      return;
    }
    return {
      value: props.selectedItemsNameList
    };
  }

  callSaveJobAndUpdatePay(jobDetails) {
    const {
      orgJobTitle,
      jobCode,
      workLocationExact,
      orgJobId,
      jobEditSection,
      saveJobAndUpdatePay,
      quickUpdateJobDetailsAndPay,
      isMP
    } = this.props;
    let saveJob = isMP ? saveJobAndUpdatePay : quickUpdateJobDetailsAndPay;
    if (!quickUpdateJobDetailsAndPay) {
      saveJob = saveJobAndUpdatePay;
    }
    if (jobEditSection === 'skills') {
      saveJob(
        {
          orgJobTitle: orgJobTitle,
          orgJobCode: jobCode,
          workLocation: workLocationExact,
          orgJobId: orgJobId,
          jobDetails: jobDetails
        },
        {
          Skills: jobDetails.SkillNameList,
          reportTypes: ['payReport']
        }
      );
    } else if (jobEditSection === 'certs') {
      saveJob(
        {
          orgJobTitle: orgJobTitle,
          orgJobCode: jobCode,
          workLocation: workLocationExact,
          orgJobId: orgJobId,
          jobDetails: jobDetails
        },
        {
          Certifications: jobDetails.CertNameList,
          reportTypes: ['payReport']
        }
      );
    }
  }

  getOptions(input, callback) {
    const { disabled } = this.props;
    if (disabled) {
      return;
    }
    if (input && input.length >= 1) {
      this.props.itemsSearch({
        params: {
          searchParam: input
        },
        searchCallback: callback
      });
    } else {
      callback('', []);
    }
  }

  itemSelect(items) {
    const { allAvailableItemsListByJob, selectedItemsList, jobEditSection, searchItems, disabled } = this.props;

    if (items && !disabled) {
      const currentSelectedItems = Array.from(items);

      if (currentSelectedItems.length !== this.state.value.length) {
        this.setState({ value: currentSelectedItems });
        const jobDetails = {};
        let itemsSaveList = [];

        for (let valIdx = 0; valIdx < currentSelectedItems.length; valIdx++) {
          let itemAdded = 0; // eslint-disable-line prefer-const
          for (let saveIdx = 0; saveIdx < allAvailableItemsListByJob.length; saveIdx++) {
            if (allAvailableItemsListByJob[saveIdx].answer === currentSelectedItems[valIdx]) {
              itemsSaveList.push(allAvailableItemsListByJob[saveIdx]);
              itemAdded++;
            }
          }
          if (itemAdded === 0) {
            for (let saveIdx = 0; saveIdx < selectedItemsList.length; saveIdx++) {
              if (selectedItemsList[saveIdx].answer === currentSelectedItems[valIdx]) {
                itemsSaveList.push(selectedItemsList[saveIdx]);
                itemAdded++;
              }
            }
          }
          if (itemAdded === 0) {
            for (let saveIdx = 0; saveIdx < searchItems.length; saveIdx++) {
              if (searchItems[saveIdx].answer === currentSelectedItems[valIdx]) {
                itemsSaveList.push(searchItems[saveIdx]);
                itemAdded++;
              }
            }
          }
        }
        this.setState({ saveItemList: itemsSaveList });
        if (jobEditSection === 'skills') {
          jobDetails.Skills = itemsSaveList;
          jobDetails.SkillNameList = currentSelectedItems;
          jobDetails.AllSkills = allAvailableItemsListByJob;
        } else if (jobEditSection === 'certs') {
          jobDetails.Certifications = itemsSaveList;
          jobDetails.CertNameList = currentSelectedItems;
          jobDetails.AllCerts = allAvailableItemsListByJob;
        }

        this.callSaveJobAndUpdatePay(jobDetails);
        if (this.props.returnSkillCertItems) {
          this.props.returnSkillCertItems(jobDetails);
        }
      } else return;
    } else return;
  }

  render() {
    const {
      selectedItemsNameList,
      possibleItems,
      headerText,
      title,
      searchPlaceholderText,
      className,
      disabled,
      isMP
    } = this.props;

    let popularItems = possibleItems.map(item => item).filter(item => !selectedItemsNameList.includes(item));
    let selectedItemsList = selectedItemsNameList;

    // if Lab use optimistic updates
    if (!isMP) {
      selectedItemsList = this.state.value;
      popularItems = possibleItems.map(item => item).filter(item => !selectedItemsList.includes(item));
    }

    const classNames = classnames({
      className,
      disabled
    });

    return (
      <SelectableItems
        className={classNames}
        initialItems={selectedItemsList}
        possibleItems={popularItems}
        headerText={headerText}
        title={title}
        searchCallback={this.getOptions.bind(this)}
        onItemsSelect={this.throttleItemSelect}
        searchPlaceholderText={searchPlaceholderText}
      />
    );
  }
}
